<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  text: string
  x: number
  y: number
  width: number
  height: number
}

const props = defineProps<Props>()

// fontsize is computed by width and height
// this is how it got converted to width and height: (val * 10, val * 2)
const fontSize = computed(() => props.width / 10)
</script>

<template>
  <div
    class="absolute color-#fff z-100 max-w-95"
    :style="{
      left: `${x}px`,
      top: `${y}px`,
      fontSize: `${fontSize}px`,
    }"
  >
    {{ text }}
  </div>
</template>
